import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import CreateInvoice from "../../component/invoice/createInvoice.js";

class CreateInvoicecon extends React.Component{
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleOrganisationChange = this.handleOrganisationChange.bind(this);
      this.completeForm = this.completeForm.bind(this);

    this.state = {
        formData: {
            date: new Date(),
            reference: "",
            customer_name: "QUALIBAT",
            customer_address: "55 AVENUE KLEBER , 75116 PARIS 16",
            customer_tva: "FR72784671141",
            customer_siret: "78467114100033",
            seller_name: "",
            seller_address: "",
            seller_tva: "",
            seller_siret: "",
            audits: []
        },
        siretError: false,
        organisation: null,
        valid: true,
        submitted: false
    };

  }

  componentWillMount() {
      /* import les audits */
      if (this.props.audits.length === 0)
        this.props.getAuditsAction()
      this.fillUserInfo(this.props)

      /* import les organisations */
      this.props.getOrganisationsAction();
  }

    completeForm(data){
        let siren = data.siret.substr(0,9);
        const { formData } = this.state;
        formData["customer_name"] = data.denomination;
        formData["customer_address"] = data.adresse + ", " + data.codePostal + " " + data.ville;
        formData["customer_tva"] = "FR" + (12+3*(siren%97))%97 + siren.replace(/ /g,'');
        formData["customer_siret"] = data.siret;
        this.setState({ formData, siretError: false });
    }

    componentWillReceiveProps(nextProps) {
        this.fillUserInfo(nextProps)
    }

    fillUserInfo(nextProps){
        if(nextProps.user && "company_name" in nextProps.user){
            const { formData } = this.state;
            formData["reference"] = "A" + (Date.now()/1000).toString().substr(0, 10);
            formData["seller_name"] = nextProps.user.company_name;
            formData["seller_address"] = nextProps.user.address;
            formData["seller_tva"] = nextProps.user.tva;
            formData["seller_siret"] = nextProps.user.siret;
            this.setState({ formData });
        }
    }

    handleDateChange = id => date => {
        const { formData } = this.state;
        formData[id] = date ? date.format("YYYY/MM/DD HH:mm:ss") : "";
        this.setState({ formData });
    };

    handleOrganisationChange(event){
        let organisation = this.props.listOfOrganisations.find(org => org.id === event.target.value)
        this.setState({ organisation: organisation});
    };

  handleInputChange(event) {
    if (event.target.name !== "longitude" && event.target.name !== "latitude") {
      const { formData } = this.state;
      formData[event.target.name] = event.target.value;
      if (this.state.formData.audits.length > 0) {
        this.setState({formData, valid:true})
      } else {
        this.setState({ formData });
      }
    }
  }

  handleFormSubmit(e){
    e.preventDefault();
    if (this.state.formData.audits.length === 0) {
      this.setState({valid:false})
    } else {
        if(this.state.formData.customer_siret !== ""){
          this.setState({ submitted: true, valid:true }, () => {
              this.props.createInvoiceAction(this.state.formData).then(res => {
                  this.props.history.replace('/invoices');
              }).catch(err => {
                  this.setState({
                      submitted: false
                  })
              })
          })
      }else{
        this.setState({
            submitted: false,
            siretError: true
        })
      }

    }
  }

  render(){
    return <CreateInvoice
        siretError={this.state.siretError}
        completeForm={this.completeForm}
      listOfOrganisations={this.props.listOfOrganisations}
      organisation={this.state.organisation}
      handleOrganisationChange={this.handleOrganisationChange}
      formData={this.state.formData}
      submitted={this.state.submitted}
      handleFormSubmit={this.handleFormSubmit}
      handleInputChange={this.handleInputChange}
      handleDateChange={this.handleDateChange}
      audits={this.props.audits.filter(audit => (audit.status === "valid" || audit.status === "reject" || audit.status === "issue_invoiced") && audit.invoices.length === 0)}
      user={this.props.user}
      valid={this.state.valid}
    ></CreateInvoice>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(CreateInvoicecon);



// WEBPACK FOOTER //
// ./src/container/invoice/createInvoice-container.js